export enum ManagementFeeDeterminedByActualExpenses {
  YES = 1, // כן
  NO = 2, // לא
}

export enum ManagementFeePathFeatures {
  NOT_RELEVANT = 0, // לא רלוונטי
  FIXED_RATE = 1, // שיעור קבוע
  VARIABLE_BY_DEPOSIT_TENURE = 2, // מהפקדה: משתנה לפי ותק הפקדות
  VARIABLE_BY_DEPOSIT_AND_SAVINGS_TENURE = 3, // מהפקדה: משתנה לפי ותק הפקדות ו/או צבירה
  LOWER_OF_FIXED_OR_AMOUNT = 4, // מהפקדה : שיעור קבוע/סכום לפי הנמוך
  VARIABLE_BY_SAVINGS = 5, // מהפקדה: משתנה לפי צבירה
  SAVINGS_TILL_2004 = 6, // צבירה: משתנים לפוליסות משתתפות עד 2004
  SAVINGS_BY_AMOUNT = 7, // צבירה: משתנים לפי צבירה
  SAVINGS_BY_AGE = 8, // צבירה: משתנים לפי גיל
  SAVINGS_BY_TENURE = 9, // צבירה: משתנים לפי ותק הפקדות
  OTHER_CONDITIONS = 10, // משתנים לפי מספר פרמטרים
}

export enum UniformManagementFee {
  NOT_RELEVANT = 0, // לא רלוונטי
  YES = 1, // כן
  NO = 2, // לא
}

export enum AllocationType {
  NOT_RELEVANT = 0, // לא רלוונטי
  COMPENSATION = 1, // פיצויים
  EMPLOYEE_PENSION = 2, // תגמולים עובד
  EMPLOYER_PENSION = 3, // תגמולים מעביד
}

export enum IsBenefitApplicable {
  YES = 1, // כן
  NO = 2, // לא
}

export enum BenefitType {
  NO_CONDITIONS = 1, // אין התניות
  TIME_LIMITED = 2, // מוגבלת בזמן
  DEPOSIT_AMOUNT_DEPENDENT = 3, // מותנת בגובה ההפקדה
  SAVINGS_AMOUNT_DEPENDENT = 4, // מותנת בגובה הצבירה
  EMPLOYER_OR_UNION_DEPENDENT = 5, // מותנת בשיוך למעסיק או לארגון עובדים
  OTHER_CONDITIONS = 6, // מותנת בתנאים נוספים
}

export enum SurvivorsWaiverType {
  NOT_EXISTS = 0, // לא קיים
  FULL_WAIVER = 1, // ויתור מלא
  CHILDREN_ONLY = 3, // ילדים בלבד
  SPOUSE_ONLY = 4, // בן זוג בלבד
}

export enum DevelopingDisability {
  YES = 1, // יש
  NO = 2, // אין
}

export enum InsuranceWaiver {
  YES = 1, // יש
  NO = 2, // אין
  NOT_RELEVANT = 3, // לא רלוונטי
}

export enum InsuranceBenefit {
  YES = 1, // כן
  NO = 2, // לא
  UNKNOWN = 3, // לא ידוע
}
export enum GuaranteedConversionFactor {
  YES = 1, // כן
  NO = 2, // לא
}

export enum YieldImpact {
  YES = 1, // כן
  NO = 2, // לא
}

export enum LifeExpectancyImpact {
  YES = 1, // כן
  NO = 2, // לא
}

export enum BeneficiaryIdentificationType {
  INDIVIDUAL = 1,       // פרטי
  CORPORATION = 2,      // תאגיד
  LEGAL_HEIRS = 3,      // יורשים חוקיים
  WILL = 4,             // צוואה
  SURVIVOR = 5,         // שאיר
  OTHER = 6,            // אחר
  NOT_SPECIFIED = 7     // לא נקבעו מוטבים ע"י הלקוח
}

export enum BeneficiaryIDCode {
  ID_NUMBER = 1,       // מספר תעודת זהות
  PASSPORT = 2,        // מספר דרכון
  OTHER = 3            // אחר
}

export enum RelationType {
  PARENTS = 1,              // הורים
  SPOUSE = 2,               // בן/בת זוג
  CHILD = 3,                // ילד/ה
  SIBLING = 4,              // אח/אחות
  GIFT_GIVER = 5,           // מעניק מתנה
  GUARDIAN = 6,             // אפוטרופוס
  EMPLOYER = 7,             // מעסיק
  OTHER = 8,                // אחר
  BANK_LENDER = 9,          // בנק מלווה (עבור משכנתאות)
  INSTITUTIONAL_LENDER = 10,// מוסדי מלווה (עבור משכנתאות)
  OTHER_LENDER = 11         // מלווה אחר (עבור משכנתאות)
}

export enum BeneficiaryDefinition {
  REGULAR = 1,            // רגיל
  IRREVOCABLE = 2         // בלתי חוזר
}

export enum BeneficiaryType {
  LIFE_BENEFICIARY = 1,   // מוטב למקרה חיים
  DEATH_BENEFICIARY = 2   // מוטב למקרה מוות
}



export interface RetirementSavingsByAge {
    retirement_age?: number; // גיל פרישה לחישוב
    total_expected_savings_with_premiums?: number; // סה"כ סכום חיסכון מצטבר צפוי בגיל פרישה (כולל פרמיות)
    projected_savings_without_premiums?: number; // צבירת חיסכון חזויה לגיל פרישה לחישוב (ללא פרמיות)
    guaranteed_conversion_factor?: number; // מקדם מובטח לפרישה
    life_expectancy_guaranteed?: number; // Enum: GuaranteedConversionFactor | קיים מקדם המרה הכולל הבטחת תוחלת חיים
    conditional_life_expectancy_guarantee?: number; // Enum: GuaranteedConversionFactor | קיימת הבטחת תוחלת החיים מותנית בבחירת מסלול פרישה
    plan_name?: string; // שם המסלול
    guaranteed_yield_conversion_factor?: number; // Enum: GuaranteedConversionFactor | קיים מקדם המרה המגלם הבטחת תשואה
    yield_conversion_period_limited?: number; // Enum: GuaranteedConversionFactor | מקדם ההמרה המגלם הבטחת תשואה מוגבל בתקופה
    restriction_period_years?: number; // תקופת הגבלה (בשנים)
    life_expectancy_changes_affect_pension?: number; // Enum: LifeExpectancyImpact | שינויים בתוחלת החיים משפיעים על עדכון קצבה
    yield_changes_affect_pension?: number; // Enum: YieldImpact | שינויים בתשואה משפיעים על עדכון קצבה
    expected_retirement_pension_rate?: number; // שיעור פנסיית זיקנה צפויה
  }
  

 

  export enum PensionFeeExpenseType {
    NOT_RELEVANT = 0, // לא רלוונטי
    FROM_SAVINGS = 1, // דמי ניהול מצבירה
    FROM_DEPOSITS = 2, // דמי ניהול מהפקדה
  }

  export enum PensionFundType {
    PAYING = 1, // משלמת
    NON_PAYING = 2, // לא משלמת
    TRAINING_FUND = 3, // קרן השתלמות
  }
  export enum PolicyEmploymentStatus {
    EMPLOYEE = 1, // שכיר
    SELF_EMPLOYED = 2, // עצמאי
    CONTROLLING_OWNER = 3, // בעל שליטה
    OTHER = 4, // אחר
    PRIVATE = 5, // פרט
    SELF_EMPLOYED_AND_EMPLOYEE = 6, // עצמאי ושכיר
    REIRED = 99, // פנסיונר
    UNEMPLOYED = 200, // לא עובד.ת
    KIBBUTZ_MEMBER = 300, // חבר.ת קיבוץ
    STUDENT = 400, // סטודנט.ית
    SOLDIER = 500, // חייל.ת
    YESHIVA_STUDENT = 600, // תלמיד ישיבה
  }
  
  export enum ExternalCoverage {
    YES = 1, // כן
    NO = 2, // לא
  }
   
  export enum PensionPlanType {
    BASIC = 1, // יסוד
    COMPREHENSIVE = 2, // מקיפה
    GENERAL = 3, // כללית
  }
  
  export enum PensionRegulationType {
    OLD_SCHEME = 1, // ותיקה
    NEW_SCHEME = 2, // חדשה
  }
  
  export enum PensionMembershipStatus {
    INSURED = 1, // מבוטח
    NOT_INSURED = 2, // לא מבוטח
    NOT_RELEVANT = 3, // לא רלוונטי
  }
  
  export enum YieldGuaranteeType {
    YES = 1, // כן
    NO = 2, // לא
  }
  
  export enum Tikun190Option {
    YES = 1, // כן
    NO = 2, // לא
  }
  
  export enum InsuranceCoverageType {
    INDIVIDUAL = 1, // אישי
    GROUP = 2, // קבוצתי
    BOTH = 3, // קיימים כיסויים מסוג אישי וגם מסוג קבוצתי
  }
  
  export enum MortgageInsurance {
    YES = 1, // כן
    NO = 2, // לא
  }
  export enum DesignatedBondEligibility {
    DesignatedBondsOnly = 1, // כן, באמצעות אג"ח מיועדות בלבד
    DesignatedBondsOrGuaranteedYield = 2, // כן באמצעות אג"ח מיועדות ו/או מנגנון אפיק השקעה מובטח תשואה
    PolicyTermsOrFundRegulation = 3, // כן, באמצעות הבטחת תשואה מתוקף תנאי הפוליסה או תנאי תקנון קופת הגמל
    No = 4, // לא
  }

  export interface PensionData {
    employment_status?: number; // PolicyEmploymentStatus
    external_coverage?: number; // ExternalCoverage
    pension_plan_type?: number; // PensionPlanType
    pension_regulation_type?: number; // PensionRegulationType
    pension_membership_status?: number; // PensionMembershipStatus
    yield_guarantee_type?: number; // YieldGuaranteeType
    is_designated_bond_eligible?: number; // KOLEL-ZAKAUT-AGACH  DesignatedBondEligibility
    designated_bond_percentage?: number;
    tikun_190_option?: number; // Tikun190Option
    insurance_coverage_type?: number; // InsuranceCoverageType
    mortgage_insurance?: number; // MortgageInsurance
  
    // שדות תאריך
    start_date_temporary_risk?: string; // TAARICH-TCHILA-RISK-ZMANI
    end_date_temporary_risk?: string; // TOM-TOKEF-RISK-ZMANI
    last_improved_insured_date?: string; // TAARICH-ACHRON-MOTAV-MUVET
    yield_guarantee_end_date?: string; // TAARICH-CIUM-AVTACHT-TESOA
  }
  
  export interface ManagementFeeDetails {
    fee_determined_by_actual_expenses?: number; // Enum: ManagementFeeDeterminedByActualExpenses | גובה דמי ניהול על פי הוצאות בפועל
    expense_type?: number; // Enum: PensionFeeExpenseType | סוג הוצאה
    path_code?: string; // קוד מסלול דמי ניהול
    path_features?: number; // Enum: ManagementFeePathFeatures | מאפייני מסלול דמי ניהול
    management_fee_rate?: number; // שיעור דמי ניהול
    last_rate_update_date?: string; // תאריך עדכון אחרון של שיעור דמי הניהול
    uniform_management_fee?: number; // Enum: UniformManagementFee | האם דמי ניהול אחידים לכל מסלולי ההשקעה
    unique_investment_path_code?: number; // קוד מסלול ההשקעה בעל דמי הניהול הייחודיים
    allocation_type?: number; // Enum: AllocationType | אופן הפרשה
    max_fee_amount?: number; // סכום מכסימלי של דמי ניהול מהפקדה
    total_fees_path?: number; // סך דמי ניהול למסלול
    other_fees?: number; // סך דמי ניהול אחרים
    is_benefit_applicable?: number; // Enum: IsBenefitApplicable | האם קיימת הטבה בדמי ניהול
    benefit_type?: number; // Enum: BenefitType | סוג הטבה
    benefit_percentage?: number; // אחוז הטבה בדמי ניהול
    benefit_expiration_date?: string; // תאריך סיום תוקף הטבה בדמי ניהול
  }
  
  export interface PensionFundDetails {
    fund_type?: number; // Enum: PensionFundType | סוג קופה
    retirement_pension_amount?: number; // סכום קצבת זקנה
    expected_monthly_pension?: number; // קצבת זקנה/גמלא חודשית צפויה
    forecast_yield_percentage?: number; // אחוז תשואה בתחזית
    total_expected_balance_with_premiums?: number; // סה"כ יתרה צפויה לגיל פרישה מחושב המיועדת להון (כולל פרמיות עתידיות)
    expected_savings_without_premiums?: number; // צבירת חיסכון צפויה להון (ללא פרמיות)
    total_accumulated_amount_with_premiums?: number; // סה"כ סכום מצטבר צפוי לגיל פרישה מחושב המיועד לקצבה (כולל פרמיות עתידיות)
    total_accumulated_amount_without_premiums?: number; // סה"כ סכום מצטבר צפוי לגיל פרישה מחושב המיועד לקצבה (ללא פרמיות עתידיות)
    at_age?: number; // גיל - מוצג רק כשיש 11 שורות PAYING (60-70)
  }
  